<div class="modal-backdrop" *ngIf="isVisible"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display': isVisible ? 'block' : 'none'}">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add Note - {{ candidateName }}</h5>
        <button type="button" class="close" aria-label="Close" (click)="onClose()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="successMessage" class="alert alert-success text-center" role="alert">
          {{ successMessage }}
        </div>
        
        <div *ngIf="!successMessage">
          <div class="form-group">
            <label for="noteType" class="font-weight-bold">Note Type <span class="text-danger">*</span></label>
            <select 
              class="form-control" 
              id="noteType" 
              [(ngModel)]="selectedNoteType"
              [disabled]="loading">
              <option value="" disabled>Select Type</option>
              <option *ngFor="let type of noteTypes" [value]="type">{{ type }}</option>
            </select>
          </div>
          
          <div class="form-group">
            <label for="comments" class="font-weight-bold">Comments <span class="text-danger">*</span></label>
            <textarea 
              class="form-control" 
              id="comments" 
              rows="6" 
              [(ngModel)]="noteComments"
              [disabled]="loading"
              placeholder="Enter your comments here...">
            </textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button 
          type="button" 
          class="btn btn-success" 
          (click)="onCancel()"
          [disabled]="loading">
          Cancel
        </button>
        <button 
          type="button" 
          class="btn btn-danger" 
          (click)="onSave()"
          [disabled]="!isFormValid() || loading">
          Save
        </button>
      </div>
    </div>
  </div>
</div>